import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

import { KYMW4402Component } from './kymw4402.component';
import { GetCoopListService } from './api-services/get-coop-list.service';
import { CopyPageInfoToCoopsService } from './api-services/copy-page-info-to-coops.service';

/**
 * 生協間コピー設定画面 モジュール設定クラス
 *
 * @export KYMW4402Module
 * @class KYMW4402Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [KYMW4402Component],
  providers: [GetCoopListService, CopyPageInfoToCoopsService],
})
export class KYMW4402Module {}
